import { ContentClassEnum } from 'content-service-client';
import { SearchUrlParamKeys } from 'search-gateway-client';
import type { SearchContentClass } from 'stockblocks-client/src/StockblocksClient';

import { filterConfig } from './FilterConfig';
import { FilterConfig, FilterOption } from './FilterTypes';

function getCategoriesBySearchParamsApplied(
    contentClass: ContentClassEnum,
    searchParams: URLSearchParams,
): FilterOption[] {
    const filterKey = mapContentClassToFilterKey(contentClass);
    return filterConfig[filterKey]
        .filter((obj: FilterConfig) => obj.key === SearchUrlParamKeys.CATEGORIES && obj.enableCondition?.(searchParams))
        .flatMap((obj: FilterConfig) => obj.options);
}

/**
 * Maps ContentClassEnum values to SearchContentClass keys used in filterConfig.
 * ContentClassEnum.Image is 'image' (singular) but filterConfig uses 'images' (plural).
 */
function mapContentClassToFilterKey(contentClass: ContentClassEnum): SearchContentClass {
    // ContentClassEnum values are: "audio", "video", "image"
    // filterConfig keys are: "audio", "video", "images"
    if (contentClass === ContentClassEnum.Image) {
        return 'images';
    }
    // TypeScript knows contentClass is now "audio" | "video", which match SearchContentClass
    return contentClass as SearchContentClass;
}

export const CategoryLinkUtils = {
    getCategoriesBySearchParamsApplied,
};
